import type { ChannelsTranslations } from '../interfaces/channels';

export const channelsTranslations: ChannelsTranslations = {
  page_title: 'Canais',
  page_description:
    'Conecte um canal e escolha o agente que responde quando um cliente envia uma mensagem.',

  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram',
  channel_web: 'Chat web',
  coming_soon: 'Em breve',
  coming_soon_description:
    'Estamos trabalhando nesta integração. Avisaremos quando estiver pronta.',

  binding_title: 'Agente que responde',
  binding_description:
    'O agente selecionado responde a todas as mensagens recebidas neste canal.',
  binding_loading: 'Carregando vínculo…',
  binding_field_label: 'Agente ativo',
  binding_field_placeholder: 'Escolha um agente',
  binding_field_no_agents: 'Você ainda não tem agentes.',
  binding_no_agents_cta: 'Criar seu primeiro agente',
  binding_save: 'Salvar alterações',
  binding_save_first_time: 'Vincular agente',
  binding_status_active: 'Ativo',
  binding_status_inactive: 'Pausado',
  binding_status_unbound: 'Sem agente vinculado',
  binding_pause: 'Pausar respostas',
  binding_resume: 'Retomar respostas',
  binding_unbind: 'Desvincular',
  binding_open_agent: 'Abrir agente',
  binding_uses_default:
    'Herda do default ({{agent}}) até você vincular um próprio.',

  default_section_title: 'Default para todos os números',
  default_section_description:
    'Usado por cada telefone deste canal a menos que você sobrescreva abaixo.',
  phones_section_title: 'Números do WABA',
  phones_section_description:
    'Cada linha pode usar o agente default ou ter um próprio — útil para separar vendas e suporte.',
  phones_count: '{{count}} número',
  phone_inherits_default: 'Usa o default ({{agent}})',
  phone_no_default:
    'Sem agente default — as mensagens recebidas são descartadas.',
  phone_customize: 'Personalizar',
  phone_collapse: 'Ocultar configuração própria',

  unbind_dialog_title: 'Desvincular este canal?',
  unbind_dialog_description:
    'O número deixa de responder imediatamente. Você pode vincular novamente quando quiser.',
  unbind_dialog_confirm: 'Desvincular',
  unbind_dialog_cancel: 'Cancelar',

  must_connect_first:
    'Conecte este canal primeiro para escolher o agente que responde.',

  toast_bound: 'Agente vinculado ao canal.',
  toast_swapped: 'Agente ativo atualizado.',
  toast_paused: 'Canal pausado.',
  toast_resumed: 'Canal retomado.',
  toast_unbound: 'Canal desvinculado.',

  error_agent_not_found:
    'Esse agente não está mais disponível. Escolha outro.',
  error_phone_not_found:
    'Esse número não está conectado à sua conta. Reconecte o WhatsApp.',
  error_invalid_channel: 'Este canal não é suportado.',
  error_unknown: 'Algo deu errado. Tente novamente.',
};
